import { defineStore } from 'pinia';
import services from '@/services';
import useApi from '@/hooks/useApi';
import useInfo from './info';
import utils from '@/utils/index';
import { Swiper } from 'swiper';
const { getParam } = utils;

interface EventsItem {
  bgLandscape: string;
  bgPortrait: string;
  logo: string;
  title: string;
  slogan: string;
  eventTime: number;
  peakDay: number;
  isAnniversaryEvent: boolean;
}

interface HomeState {
  annualTimeline: {
    year: number;
    events: EventsItem[];
  }[];
  milestones: {
    title: string;
    videoCover: string;
    youtubeId: string;
    description: string;
    kvImageLandscape: string;
    kvImagePortrait: string;
  }[];
  currentYear: number | null;
  activeIndex: number;
  thumbsSwiper: Swiper | null;
  isInitialized: boolean;
}

const homeState = (): HomeState => ({
  annualTimeline: [],
  milestones: [],
  currentYear: null,
  activeIndex: 0,
  thumbsSwiper: null,
  isInitialized: false,
});

const useHome = defineStore('home', {
  state: homeState,
  getters: {
    currentYearEvents(): EventsItem[] {
      if (this.annualTimeline.length > 0) {
        let events = [
          ...this.annualTimeline.filter(
            (event) => event.year === this.currentYear,
          )[0].events,
        ];
        const anniversaryIndex = events.findIndex(
          (event) => event.isAnniversaryEvent,
        );
        if (anniversaryIndex > 0) {
          events = [...events.splice(anniversaryIndex, 1), ...events];
        }
        return events;
      }
      return [];
    },
    currentBg(): { bgLandscape: string; bgPortrait: string } {
      const currentYearEvent = this.currentYearEvents[this.activeIndex];
      return {
        bgLandscape: currentYearEvent?.bgLandscape || '',
        bgPortrait: currentYearEvent?.bgPortrait || '',
      };
    },
  },
  actions: {
    async getHome() {
      const { lang, region } = useInfo();
      if (!lang || !region) return;
      const accessToken =
        getParam('access_token') || localStorage.getItem('TOKEN');
      const response = await useApi(() =>
        services.getHome({ lang, region, ...(accessToken && { accessToken }) }),
      );
      if (!response || response.msg) return;
      const { data } = response;
      this.$patch({ ...data });
      if (data.annualTimeline.length > 0) {
        this.setCurrentYear(data.annualTimeline[0]['year']);
      }
      this.setIsInitialized(true);
    },
    setIsInitialized(boolean: boolean) {
      this.isInitialized = boolean;
    },
    setCurrentYear(year: number) {
      this.currentYear = year;
    },
    setActiveIndex(number: number) {
      this.activeIndex = number;
    },
    setThumbsSwiper(swiper: Swiper | null) {
      this.thumbsSwiper = swiper;
    },
  },
});

export default useHome;
